import { t } from 'i18next';
import {
  Activity,
  FileJson,
  LayoutDashboard,
  Puzzle,
  Scale,
  Table2,
} from 'lucide-react';

import {
  isDevAdmin,
  useAdminSession,
} from '@/features/internal-admin/lib/admin-session';

import { AdminSidebar, AdminSidebarLink } from './admin-sidebar';

export const AdminContainer = ({ children }: { children: React.ReactNode }) => {
  const { data: session } = useAdminSession();

  // One entry per question: Overview is the glance on landing, Explorer answers
  // "find me this client", Catalog answers "can Khub do X with Y", Health
  // answers "is it broken", Fair queue is its own live tool. The last two are
  // developer tooling, shown to developers only.
  const links: AdminSidebarLink[] = [
    {
      to: '/internal-admin/home',
      label: t('Overview'),
      icon: LayoutDashboard,
    },
    {
      to: '/internal-admin/overview',
      label: t('Explorer'),
      icon: Table2,
    },
    {
      to: '/internal-admin/catalog',
      label: t('Catalog'),
      icon: Puzzle,
    },
    {
      to: '/internal-admin/swaggers',
      label: t('Swaggers'),
      icon: FileJson,
    },
    ...(isDevAdmin(session)
      ? [
          {
            to: '/internal-admin/health',
            label: t('Health'),
            icon: Activity,
          },
          {
            to: '/internal-admin/fair-queue',
            label: t('Fair Queue'),
            icon: Scale,
          },
        ]
      : []),
  ];

  return <AdminSidebar links={links}>{children}</AdminSidebar>;
};
